import React from 'react';
import { anchor } from '../../../components/shared/vector-images';
import Text from '../../../components/shared/_deprecated/elements/Text/Text';
import {
  onInitializeStandardMarker,
  onToggleStandardMarker,
} from '../_helpers';

const layer = {
  displayName: 'Anchorage',
  synonyms: '',
  group: 'standardMarker',
  typeUrl: 'anchorage',
  icon: {
    baseShape: anchor,
    iconColor: '#fff',
    markerColor: '#139ECA',
  },
  shownByDefault: true,
  relativeDepth: 0,
  menuOptions: {
    visible: true,
    owningMenu: 'marine-points-of-interest',
    order: 5,
  },
  standardMarkerOptions: {
    markerType: 'anchorageMarker',
    allowCreation: true,
    allowEditing: false,
    allowComments: true,
    viewOptions: {
      typeTitle: 'Anchorage',
      itemTitleFunction: (item) => (item && item.title) || 'Anchorage',
    },
    creationOptions: {
      menuText: 'Anchorage',
      newTitle: 'Anchorage',
      titlePlaceholder: 'Name of anchorage',
      markerTypeDescription: [
        <Text key="description-text-1" size="-1" paragraph>
          Include information such as depth, holding ground and wind protection.
        </Text>,
        <Text key="description-text-2" size="-1" paragraph>
          Information provided should be factual. Once you submit this marker,
          you can add your personal experiences or questions as a comment
          underneath.
        </Text>,
      ],
      checkBoxItems: [
        { label: 'Very good holding', isActive: false },
        { label: 'Good holding', isActive: false },
        { label: 'Average holding', isActive: false },
        { label: 'Poor holding', isActive: false },
        { label: 'Sand', isActive: false },
        { label: 'Mud', isActive: false },
        { label: 'Coral', isActive: false },
        { label: 'Rock', isActive: false },
        { label: 'Sand & rock', isActive: false },
        { label: 'Deep (8m / 26ft or more)', isActive: false },
        { label: 'Shallow (2m / 6ft or less)', isActive: false },
        { label: 'Very shallow (1m / 3ft or less)', isActive: false },
        { label: 'Protected', isActive: false },
        { label: 'Exposed', isActive: false },
        { label: 'Noisy', isActive: false },
        { label: 'Quiet', isActive: false },
        { label: 'Social', isActive: false },
        { label: 'Phone or Internet reception', isActive: false },
        { label: 'No Phone or internet reception', isActive: false },
        { label: 'VHF reception', isActive: false },
        { label: 'No VHF reception', isActive: false },
      ],
    },
    editingOptions: {},
  },
  markerSummaryConfig: {
    displayChat: true,
    title: 'Anchorage',
  },
  popOverConfiguration: (marker) => ({
    markerType: layer.standardMarkerOptions.markerType,
    id: marker.id,
    displayChat: true,
    displayUpVotes: true,
    title: 'Anchorage',
    description: marker.title,
  }),
};

layer.onInitialize = onInitializeStandardMarker(layer);
layer.onToggle = onToggleStandardMarker(layer);

export default layer;
